import React from 'react'
import PropTypes from 'prop-types'
import { lightFormat } from 'date-fns'
import { dateWithTime } from 'constants/dateFormats'

export const DateTimeCell = ({ value }) => {
  return !value ? (
    '–'
  ) : (
    <span>{lightFormat(new Date(value), dateWithTime)}</span>
  )
}

DateTimeCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
